/**
 * Unified utility function to generate API URLs based on the current environment
 * Compatible with both existing app structure and imported MapEditor components
 * @param {string} target - The API endpoint to call
 * @returns {string} The complete API URL
 */
function APIURLMaker(target) {
  // More reliable development check
  //const isDevelopment = process.env.REACT_APP_API_SERVER === "localhost";

  /*if (isDevelopment) {
    // Use proxy in development
    return `/api/${target}`;
  }*/

  // Build full URL for production/staging
  const PROTOCOL = process.env.REACT_APP_API_PROTOCOL;
  const SERVER = process.env.REACT_APP_API_SERVER;
  const PORT = process.env.REACT_APP_API_PORT;
  const API_PATH = process.env.REACT_APP_API_PATH || 'api';

  // Ensure target is properly encoded
  const encodedTarget = encodeURIComponent(target).replace(/%2F/g, "/");

  // Make sure target starts with a slash
  const formattedTarget = encodedTarget.startsWith('/') ? encodedTarget : `/${encodedTarget}`;

  // Construct the URL with the API_PATH
  let retval = `${PROTOCOL}://${SERVER}${PORT ? `:${PORT}` : ""}/${API_PATH}${formattedTarget}`;

  return retval;
}

export default APIURLMaker;
